<template>
  <div class="action-group">
    <SButtonMaterial
      class="view-profile-btn"
      :md-ripple="false"
      buttonType="button"
      textColor="white"
      color="primary"
      iconColor="white"
      materialClass="dense"
      :text="text"
      :iconLeftText="icon"
      @button="$emit('setAction')"
      :data-cy="dataCy"
    />
  </div>
</template>

<script>
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";

export default {
  name: "SButtonViewProfile",
  props: ["text", "dataCy", "icon"],
  components: {
    SButtonMaterial,
  },
};
</script>

<style lang="scss" scoped>
.action-group {
  display: flex;
  flex-direction: row;
}

.set-action {
  cursor: pointer;
  color: $white;
  font-size: 16px;
  width: 188px;
  display: flex;
  align-items: center;
  text-align: center;
  margin-left: -2.8rem;
}

.set-action:hover {
  color: $primary;
}
</style>

<style>
.view-profile-btn .md-ripple {
  width: 290px;
}
.view-profile-btn i {
  font-size: 25px !important;
}
</style>
